import type { SystemMessage } from '@xsai/shared-chat'

import { EMOTION_EmotionMotionName_value, EMOTION_VALUES, LIVE2D_EXPRESSION_VALUES } from '../emotions'

function message(prefix: string, suffix: string) {
  return {
    role: 'system',
    content: [
      prefix,
      EMOTION_VALUES
        .map(emotion => `- ${emotion} (Emotion for feeling ${EMOTION_EmotionMotionName_value[emotion]})`)
        .join('\n'),
      `\nAvailable Live2D expressions:\n${LIVE2D_EXPRESSION_VALUES
        .map(expr => `- ${expr}`)
        .join('\n')}`,
      suffix,
    ].join('\n\n'),
  } satisfies SystemMessage
}

export default message
